import {Dispatch} from "redux";
import {ordersType} from "../../components/account/types";

export const SET_ORDERS = "SET_ORDERS";
export const CLEAR_ORDERS = "CLEAR_ORDERS";

export const setOrders = (orders: ordersType[]) => ({
    type: SET_ORDERS,
    payload: orders,
});

export const clearOrders = () => ({
    type: CLEAR_ORDERS
});

export const fetchOrders = (customerId: number, token: string) => {
    return async (dispatch: Dispatch) => {
        try {
            const res = await fetch(
                `/api/orders?customer_id=${customerId}&token=${token}&limit=100`
            );
            const data = await res.json();

            dispatch(setOrders(data?.data || []));
        } catch (error) {
            console.error("Error on fetching data:", error);
        }
    };
};
